/* eslint-disable max-len */

import React from 'react';
import PropTypes from 'prop-types';

/* Generic icon component for all icons in our icon font */

const Icon = ({
  name, large, className, tooltip,
}) => {
  const css = `Icon Icon-${name}${large ? ' Icon--large' : ''} ${className}`;

  return (tooltip ? <i className={css} data-tooltip="" title={tooltip} /> : <i className={css} />);
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  large: PropTypes.bool,
};

Icon.defaultProps = {
  className: '',
  tooltip: null,
  large: false,
};

export default Icon;

/* Additional SVG icons (see git.io/vx4wd for context) */

export const CloseIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z" />
  </svg>
);

export const CommentIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
    <path d="M87.913,43.843c0-21.239-17.214-38.458-38.455-38.458C28.216,5.385,11,22.604,11,43.843    c0,20.782,16.485,37.699,37.092,38.418c2.958,2.88,12.534,10.995,23.374,7.69c0,0,3.226-0.883,1.506-3.521    c-1.088-1.669-3.257-5.437-4.747-9.021C79.969,70.829,87.913,58.262,87.913,43.843z M56.999,56.72H34.922    c-2.255,0-4.087-2.299-4.087-5.136c0-2.827,1.832-5.122,4.087-5.122h22.077c2.257,0,4.087,2.294,4.087,5.122    C61.086,54.421,59.256,56.72,56.999,56.72z M63.651,39.797H35.963c-2.836,0-5.128-2.298-5.128-5.129    c0-2.833,2.292-5.126,5.128-5.126h27.688c2.83,0,5.127,2.293,5.127,5.126C68.778,37.499,66.481,39.797,63.651,39.797z" />
  </svg>
);

export const SearchIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M15.7 13.3l-3.81-3.83A5.93 5.93 0 0 0 13 6c0-3.31-2.69-6-6-6S1 2.69 1 6s2.69 6 6 6c1.3 0 2.48-.41 3.47-1.11l3.83 3.81c.19.2.45.3.7.3.25 0 .52-.09.7-.3a.996.996 0 0 0 0-1.41v.01zM7 10.7c-2.59 0-4.7-2.11-4.7-4.7 0-2.59 2.11-4.7 4.7-4.7 2.59 0 4.7 2.11 4.7 4.7 0 2.59-2.11 4.7-4.7 4.7z" />
  </svg>
);
